/* =============================================================
   D'Avila — notas e contagem de avaliações AO VIVO (Konfidency)
   =============================================================
   As estrelas do tema (PDP, conjunto, cards, rodapé) são o NOSSO layout,
   renderizado pelo Liquid a partir do metafield reviews.rating — que ficou
   congelado desde a saída do Judge.me (set/2026). Este script busca a nota e
   a contagem atuais na API pública da Konfidency (a mesma que o widget dela
   usa) e troca só os números, sem mudar o visual.

   - Marca: qualquer elemento com data-kf-sku="<id do produto Shopify>"
     (SKU na Konfidency = id do produto). Se o produto não tinha nota gravada,
     o Liquid renderiza o bloco escondido (hidden) e ele aparece quando a API
     trouxer avaliação.
   - Se a API falhar ou devolver 0, fica o valor do Liquid (nunca some estrela).
   - Uma chamada em lote por página (até 100 produtos por chamada) + cache de
     10 min na sessão.
   - Rodapé: data-kf-total = avaliações de produto + da loja.
   ============================================================= */
(function () {
  'use strict';

  var API = 'https://reviews-api.konfidency.com.br/facasdavila';
  var CACHE_KEY = 'davila-kf-ratings-v1';
  var TTL = 10 * 60 * 1000;

  function estrelas(nota) {
    var cheias = Math.round(nota), s = '';
    for (var i = 1; i <= 5; i++) s += i <= cheias ? '★' : '☆';
    return s;
  }
  function umaCasa(n) { return (Math.round(n * 10) / 10).toFixed(1); }

  function lerCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < TTL) return c.d || {};
    } catch (e) { /* sem storage */ }
    return {};
  }
  function salvarCache(d) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) { /* sem storage */ }
  }

  function aplicar(el, r) {
    if (!r || !(r.reviewCount > 0)) return;
    el.hidden = false;
    var st = el.querySelector('.davila-card__stars, .davila-rating__stars');
    if (st) st.textContent = estrelas(r.aggregateRating);
    var nota = el.querySelector('.davila-rating__score');
    if (nota) nota.textContent = umaCasa(r.aggregateRating);
    var cont = el.querySelector('.davila-rating__count');
    if (cont) cont.textContent = '(' + r.reviewCount + ' avaliações)';
    var card = el.querySelector('.davila-card__rating-text');
    if (card) card.textContent = '(' + r.reviewCount + ')';
  }

  function atualizarProdutos() {
    var els = [].slice.call(document.querySelectorAll('[data-kf-sku]'));
    if (!els.length) return;
    var cache = lerCache();
    var faltam = [];
    els.forEach(function (el) {
      var sku = el.getAttribute('data-kf-sku');
      if (!sku) return;
      if (cache[sku]) aplicar(el, cache[sku]);
      else if (faltam.indexOf(sku) === -1) faltam.push(sku);
    });
    for (var i = 0; i < faltam.length; i += 100) {
      var lote = faltam.slice(i, i + 100);
      fetch(API + '/ratings/?skus=' + lote.join(',') + '&_v=3')
        .then(function (res) { return res.ok ? res.json() : []; })
        .then(function (lista) {
          (lista || []).forEach(function (r) {
            if (r && r.sku) cache[String(r.sku)] = { aggregateRating: r.aggregateRating, reviewCount: r.reviewCount };
          });
          salvarCache(cache);
          document.querySelectorAll('[data-kf-sku]').forEach(function (el) {
            var r = cache[el.getAttribute('data-kf-sku')];
            if (r) aplicar(el, r);
          });
        })
        .catch(function () { /* mantem o valor do Liquid */ });
    }
  }

  function atualizarRodape() {
    var alvo = document.querySelector('[data-kf-total]');
    if (!alvo) return;
    var cache = lerCache();
    function pinta(t) {
      if (!t || !(t.count > 0)) return;
      alvo.textContent = umaCasa(t.rating) + ' · +' + t.count + ' avaliações';
      var bloco = alvo.closest('[data-kf-total-wrap]');
      if (bloco) bloco.hidden = false;
    }
    if (cache.__total) { pinta(cache.__total); return; }
    Promise.all([
      fetch(API + '/all-reviews?pageSize=1').then(function (r) { return r.json(); }),
      fetch(API + '/store-reviews/summary').then(function (r) { return r.json(); }),
    ]).then(function (res) {
      var prod = res[0] && res[0].reviews && res[0].reviews.summary;
      var loja = res[1] && res[1][0];
      var nProd = (prod && prod.reviewCount) || 0;
      var nLoja = (loja && loja.count) || 0;
      var total = nProd + nLoja;
      if (!total) return;
      var media = ((prod ? prod.aggregateRating * nProd : 0) + (loja ? loja.avgRating * nLoja : 0)) / total;
      cache.__total = { count: total, rating: media };
      salvarCache(cache);
      pinta(cache.__total);
    }).catch(function () { /* mantem o valor do Liquid */ });
  }

  var agendado = null;
  function rodar() { atualizarProdutos(); atualizarRodape(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rodar);
  else rodar();

  // Cards carregados depois (carregar mais, vistos recentemente, carrosseis)
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-kf-sku') || (n.querySelector && n.querySelector('[data-kf-sku]')))) {
            clearTimeout(agendado);
            agendado = setTimeout(atualizarProdutos, 300);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.davilaReviewsLive = rodar;
})();
